import React from 'react';
import { Stack } from 'library/ui';
import FilterCheckboxList from 'internal/shared/FilterCheckboxList';

export default function ProgramTypes({
    options,
    programTypes,
    onProgramTypesChanged,
}: {
    options: string[];
    programTypes: string[];
    onProgramTypesChanged: (x: string) => void;
}) {
    return (
        <Stack>
            <FilterCheckboxList
                options={options}
                selectedOptions={programTypes}
                onChange={(x) => onProgramTypesChanged(x)}
            />
        </Stack>
    );
}
